import { getNthPart, type InferParts, type NthPart } from '@solinkcorp/utils';

export type LocaleName = 'en-CA' | 'en-US' | 'en-GB' | 'fr-FR' | 'es-ES';
export type LanguagePart<LN extends LocaleName> = NthPart<InferParts<LN, '-'>, 0>;
export type SupportedLanguages = LanguagePart<LocaleName>;

/**
 * Get the 2 character version of the language code (e.g., 'en').
 *
 * @param {LocaleName} localeCode
 * @returns {LanguagePart<LocalName>} 2-char language code
 */
export const getLanguageCode = <LN extends LocaleName>(localeCode: LN): LanguagePart<LN> =>
  getNthPart(localeCode, '-', 0);
